import type { TNAPIBody } from '~/types/napi-helpers'

export function sendContactUsMessage(payload: TNAPIBody<'/napis/v1/contact_us/', 'post'>) {
  const { openAPIFetchOnce } = useAuthFetch()
  return openAPIFetchOnce('/napis/v1/contact_us/', 'post', undefined, undefined, payload)
}

export function sendContactUsMessageForCourse(
  payload: TNAPIBody<'/napis/v1/contact_us/course/', 'post'>
) {
  const { openAPIFetchOnce } = useAuthFetch()
  return openAPIFetchOnce('/napis/v1/contact_us/course/', 'post', undefined, undefined, payload)
}

type UseContactUsReturnType = {
  sendContactUsMessage: typeof sendContactUsMessage
  sendContactUsMessageForCourse: typeof sendContactUsMessageForCourse
}

export function useContactUs(): UseContactUsReturnType {
  return {
    sendContactUsMessage,
    sendContactUsMessageForCourse
  }
}
